import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Anchor, Scale, Package } from "lucide-react";
export default function MinimumOrderInfo() {
  const image = {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_minimum_order.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_minimum_order.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_minimum_order.webp-wvc-sizes",
    alt: "Freshly caught Gulf seafood packed in ice for commercial delivery"
  };
  const minimums = [{
    label: "Fresh Catch",
    value: "50 lbs",
    icon: Anchor
  }, {
    label: "Frozen Fillets",
    value: "100 lbs",
    icon: Scale
  }, {
    label: "Ready-to-Eat",
    value: "5 Cases",
    icon: Package
  }];
  return <section id="minimum-order-info" className="bg-background text-foreground py-24 md:py-40 relative overflow-hidden border-t border-border">
      {}
      <div className="absolute left-8 top-0 bottom-0 w-[1px] bg-border hidden xl:block" />

      <div className="max-w-[1440px] mx-auto px-6 md:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div className="lg:col-span-5 relative">
            {}
            <div className="absolute -left-8 top-12 -rotate-90 origin-left font-mono text-[10px] tracking-widest text-muted-foreground hidden md:block whitespace-nowrap">
              30° 24' 42" N / 88° 49' 42" W
            </div>
            
            <div className="relative border border-border p-3 bg-card shadow-xl">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} className="w-full aspect-[4/5] object-cover" loading="lazy" />
              {}
              <div className="absolute bottom-0 right-0 w-24 h-[1px] bg-primary translate-y-3 flex justify-end items-center">
                <div className="w-1 h-1 bg-primary" />
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col items-start">
            <div className="flex items-center gap-4 mb-6">
              <span className="w-8 h-[1px] bg-primary block" />
              <span className="font-mono text-xs md:text-sm uppercase tracking-widest text-muted-foreground">
                Logbook // 03
              </span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-8 leading-[1.1] tracking-tight">
              Wholesale <br className="hidden md:block" /> Minimums
            </h2>

            <p className="font-sans text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed">
              To maintain the exceptional quality and freshness of our wild-caught Gulf seafood, we require a minimum order volume for all commercial accounts. This ensures our captains can sustainably harvest and deliver the premium product your establishment deserves.
            </p>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 w-full mb-12 border-y border-border py-10">
              {minimums.map((item, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
                  <div className="w-12 h-12 border border-border flex items-center justify-center text-primary bg-card shadow-sm">
                    <item.icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-1.5">
                      {item.label}
                    </div>
                    <div className="font-serif text-2xl font-semibold text-foreground">
                      {item.value}
                    </div>
                  </div>
                </div>)}
            </div>

            <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-foreground hover:text-background font-mono uppercase tracking-widest px-10 py-7 text-sm shadow-md transition-colors duration-150">
              <Link to="/ContactPage">Apply for an Account</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}